export const generateId = (pre: string) => `${pre}_${new Date().getTime()}`;
